import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import reportWebVitals from './reportWebVitals';
import { Root } from './screen/root';
import { LoginScreen } from './screen/TKG_RESERVE_0100/TKG_RESERVE_0100';
import { CallbackReceive } from './screen/TKG_RESERVE_0100/CallbackReceive';
import { AwaitingApprovalScreen } from './screen/TKG_RESERVE_0110/TKG_RESERVE_0110';
import { EventListScreen } from './screen/TKG_RESERVE_0120/TKG_RESERVE_0120';
import { EventScreen } from './screen/TKG_RESERVE_0130/TKG_RESERVE_0130';
import { Navigate } from 'react-router-dom';
import { ManagerEventList } from './screen/TKG_RESERVE_0200/TKG_RESERVE_0200';
import { EventManagement } from './screen/TKG_RESERVE_0210/TKG_RESERVE_0210';
import { UserManagement } from './screen/TKG_RESERVE_0220/TKG_RESERVE_0220';
import { ArenaManagement } from './screen/TKG_RESERVE_0230/TKG_RESERVE_0230';
import { EventRegister } from './screen/TKG_RESERVE_0240/TKG_RESERVE_0240';
import { LegalNotice } from './screen/TKG_RESERVE_Z001/TKG_RESERVE_Z001';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<Root />}>
      <Route index element={<Navigate to="/login" />} />
      <Route path="login" element={<LoginScreen />} />
      <Route path="callback-receive" element={<CallbackReceive />} />
      <Route path="awaiting-approval" element={<AwaitingApprovalScreen />}/>
      <Route path="portal" element={<EventListScreen />}/>
      <Route path="event" element={<EventScreen />} />
      <Route path="legal-notice" element={<LegalNotice />} />
      <Route path="mng" >
        <Route path="portal" element={<ManagerEventList />} />
        <Route path="event" element={<EventManagement />} />
        <Route path="event_register" element={<EventRegister />} />
        <Route path="user" element={<UserManagement />} />
        <Route path="arena" element={<ArenaManagement />} />
      </Route>
    </Route>
  )
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // // TODO：以下を開発と本番で切り替える
  // // StrictMode：ON（開発用。初期表示等する際に2回読み込まれたりする。バグ発見のためにそういう動きをするらしい。）
  // <React.StrictMode>
  //   <RouterProvider router={router} />
  // </React.StrictMode>
  // StictMode：OFF（本番用）
  <RouterProvider router={router} />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
